import { render } from "./Buddy.vue?vue&type=template&id=1e1ad2bf&scoped=true"
import script from "./Buddy.vue?vue&type=script&lang=js"
export * from "./Buddy.vue?vue&type=script&lang=js"

import "./Buddy.vue?vue&type=style&index=0&id=1e1ad2bf&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1ad2bf"]])

export default __exports__